import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-host-guide',
  templateUrl: './host-guide.component.html',
  styleUrls: ['./host-guide.component.css']
})
export class HostGuideComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }
  gotoHostPage(): void {
    this.router.navigate([`/cinejoy/screening-parties/host`]);
  }
}